import { render } from "./SecuritySetting.vue?vue&type=template&id=aafa91f2&scoped=true"
import script from "./SecuritySetting.vue?vue&type=script&lang=js"
export * from "./SecuritySetting.vue?vue&type=script&lang=js"

import "./SecuritySetting.vue?vue&type=style&index=0&id=aafa91f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aafa91f2"]])

export default __exports__